<template>
  <div class="user-banner-el">
    <img class="user-banner" :src="require('@/assets/user_bg_'+tag+'.png')" alt=" ">
    <div class="page-title">
      <p class="title-text" v-if="title">{{ title }}</p>
      <span class="text-en" v-if="enTitle">{{ enTitle }}</span>
    </div>
    <div class="user-av" v-if="showAv">
        <label for="def_input">
          <img :src="getUserInfoObj.avatar || require('@/assets/default_av.png')" alt=" ">
        </label>
        <input type="file" accept="image/*" hidden id="def_input" @change="getFile">
    </div>
    <div class="user-page-tab">
      <div @click="goAccount()" :class="{'page-item selected_account':tag === 'account','page-item unselect_account':tag != 'account'}"></div>
      <div @click="goWork()" :class="{'page-item selected_works':tag === 'works','page-item unselect_works':tag != 'works'}"></div>
      <div @click="goCertificate()" :class="{'page-item selected_certificate':tag === 'certificate','page-item unselect_certificate':tag != 'certificate'}"></div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import $ from "jquery";
import OSS from "ali-oss";
import {Warning} from "@/plugins/warning";
import {updateAv} from "@/request/api";

export default {
  name: "userBannerTop",
  props:{
    showAv: {
      type: Boolean,
      default: false
    },
    title:{
      type: String,
      default: ''
    },
    enTitle:{
      type: String,
      default: ''
    },
    tag:{
      type: String,
      default: 'account'
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('infoModule',['getUserInfoObj'])
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getFile(e){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/works/uploads/index',
        data:{
          suffix:fileExt[0],
          path:"avatar"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  updateAv({avatar:data.result.data.url}).then(()=>{
                    that.$store.dispatch('infoModule/getUserInfo')
                  })
                }
              }
            });
          }else {
            Warning.open(data.msg);
          }
        }
      })
    },
    goAccount(){
      if(this.tag != 'account'){
        this.$router.push({name:'userAccountManage'})
      }
    },
    goCertificate(){
      if(this.tag != 'certificate') {
        this.$router.push({name: 'userCertificate'})
      }
    },
    goWork(){
      if(this.tag != 'works') {
        this.$router.push({name: 'userWorks'})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.user-banner-el {
  width: 100%;
  position: relative;

  .user-banner {
    display: block;
    width: 100%;
  }
  .page-title {
    padding: 85px 0 0;
    width: $mainWidth;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
  }
  .user-av {
    display: block;
    width: 156px;
    height: 156px;
    border: 5px solid #c8bb9b;
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    //bottom: -78px;
    top: 215px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9;
    label {
      display: block;
      width: 100%;
      height: 100%;
      & > img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }
    }
    & > img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .user-page-tab{
    width: 1067px;
    height: 258px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 218px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    .page-item{
      height: 258px;
      width: 309px;
      cursor: pointer;
    }
    .unselect_account{
      background: url(~@/assets/user_icon_account_unselect.png) no-repeat center center;
      background-size: 309px 258px;
    }
    .unselect_certificate{
      background: url(~@/assets/user_icon_certificate_unselect.png) no-repeat center center;
      background-size: 309px 258px;
    }
    .unselect_works{
      background: url(~@/assets/user_icon_works_unselect.png) no-repeat center center;
      background-size: 309px 258px;
    }
    .selected_account{
      background: url(~@/assets/user_icon_account_selected.png) no-repeat center center;
      background-size: 309px 258px;
    }
    .selected_certificate{
      background: url(~@/assets/user_icon_certificate_selected.png) no-repeat center center;
      background-size: 309px 258px;
    }
    .selected_works{
      background: url(~@/assets/user_icon_works_selected.png) no-repeat center center;
      background-size: 309px 258px;
    }
  }
}

</style>
